// import { generator, notFoundRouter } from '@/utils/permissions';
import { get } from '@/utils/request';
import { login, getUserInfoById, getNav } from '@/api/user';
const user = {
  namespaced: true,
  state: {
    userInfo: {},
    token: '',
    sessionTimeout: false,
    refresh: null,
    lastUpdateTime: 0,
    loginFlag: false,
    loginState: 'PASSWORD',
    phone: '',
    pwd: '',
    nav: [],
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_LOGINFLAG: (state, flag) => {
      state.loginFlag = flag;
    },
    SET_LOGINSTATE: (state, payload) => {
      state.loginState = payload.state;
      state.phone = payload.phone;
      state.pwd = payload.pwd;
    },
    SET_SESSIONTIMEOUT: (state, sessionTimeout) => {
      state.sessionTimeout = sessionTimeout;
    },
    SET_REFRESH: (state, refresh) => {
      state.refresh = refresh;
    },
    SET_USERINFO: (state, userinfo) => {
      state.userInfo = userinfo;
    },
    SET_NAV: (state, nav) => {
      state.nav = nav;
    },
  },
  getters: {
    getToken(state) {
      return state.token || window.localStorage.getItem('token');
    },
  },
  actions: {
    setToken({ commit }, token) {
      commit('SET_TOKEN', token);
      window.localStorage.setItem('token', token);
    },
    async login({ commit, dispatch }, params) {
      try {
        let data = await login(params);
        const { token, expire, sms_token } = data;
        if (sms_token) {
          const tokens = localStorage.getItem('LOGINSMSTOKEN');
          if (tokens) {
            if (
              tokens.split(',').findIndex((v) => {
                return v == sms_token;
              }) == -1
            ) {
              localStorage.setItem('LOGINSMSTOKEN', tokens + ',' + sms_token);
            }
          } else {
            localStorage.setItem('LOGINSMSTOKEN', sms_token);
          }
        }
        await dispatch('setToken', token);
        commit('SET_LOGINFLAG', false);
        const userInfo = await dispatch('getUserInfoAction');
        return userInfo;
      } catch (error) {
        commit('SET_SESSIONTIMEOUT', false);
        return Promise.reject(error);
      }
    },
    async getUserInfoAction({ commit, dispatch }) {
      const userInfo = await getUserInfoById();
      commit('SET_USERINFO', userInfo);
      dispatch('setRefresh');
      const nav = await getNav();
      commit('SET_NAV', nav);
      return userInfo;
    },
    async setRefresh({ commit, dispatch, state }) {
      if (state.refresh) {
        clearInterval(state.refresh);
      }
      let refresh = setInterval(() => {
        get('/api/v1/refresh', {})
          .then((e) => {
            dispatch('setToken', e.token);
          })
          .catch(() => {
            this.logout();
          });
      }, 60000 * 5);
      commit('SET_REFRESH', refresh);
    },
    // 登出
    async logout({ commit, state, dispatch }) {
      try {
        await get('/api/v1/logout');
      } catch (error) {
        // An expired session or unavailable server must not prevent local logout.
      } finally {
        clearInterval(state.refresh);
        commit('SET_REFRESH', null);
        await dispatch('setToken', '');
        commit('SET_USERINFO', {});
      }
    },
  },
};

export default user;
